var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4307 5.71811L9.65297 0.40123L9.64339 0.392855C9.33577 0.1239 8.93821 -0.0134252 8.53616 0.00103544C8.13404 0.0154989 7.74671 0.181172 7.45907 0.47307C7.17034 0.766068 7.00548 1.16364 7.01061 1.58252C7.01574 2.00136 7.19024 2.39456 7.48553 2.68035L7.49457 2.6891L10.4794 5.43602H1.58331C1.17428 5.43602 0.77536 5.5927 0.475999 5.88194C0.175467 6.17232 0 6.57362 0 6.99962C0 7.42562 0.175467 7.82693 0.475999 8.1173C0.775362 8.40655 1.17428 8.56322 1.58331 8.56322H10.4797L7.49454 11.3109L7.48553 11.3196C7.19024 11.6054 7.01574 11.9986 7.01061 12.4175C7.00548 12.8364 7.17034 13.2339 7.45907 13.5269C7.74672 13.8188 8.13404 13.9845 8.53616 13.999C8.9382 14.0134 9.33577 13.8761 9.64339 13.6071L9.65297 13.5988L15.4319 8.28082L15.4327 8.28003C15.7186 8.01763 15.9118 7.66626 15.9749 7.27821C16.0089 7.09188 16.0083 6.90102 15.9734 6.71491C15.9091 6.32912 15.7163 5.98002 15.4318 5.71905L15.4307 5.71811Z",
    fill: "#D8762B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYArrow);
export default __webpack_public_path__ + "static/media/y-arrow.0f403f2b6ef80385acdf6aff20e6b37c.svg";
export { ForwardRef as ReactComponent };